// extracted by mini-css-extract-plugin
export default {"Records":"Records_Records__epDuN","Wrapper":"Records_Wrapper__+vncN"};